import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { posts } from "@/mocks/posts";
import { faqs } from "@/mocks/faq";
import { site } from "@/mocks/site";
import HeroBand from "./components/HeroBand";
import CategoryStrip from "./components/CategoryStrip";
import LeadStories from "./components/LeadStories";
import FeedWithSidebar from "./components/FeedWithSidebar";
import TopicBanner from "./components/TopicBanner";
import StatsBand from "./components/StatsBand";
import CtaBand from "./components/CtaBand";

export default function Home() {
  useSeo({
    title: "网曝吃瓜 - 网友爆料投稿聚集地 | 投稿·素材·线索·原帖一站看",
    description:
      "网曝吃瓜汇集网友真实投稿与独家爆料线索，第一时间呈现事件原貌。涵盖娱乐热议、网红动态、影视综料、社会观察、品牌公关等栏目，提供吃瓜爆料、吃瓜素材、吃瓜线索、吃瓜原帖的一站式整理与追踪。",
    keywords: "网曝吃瓜,吃瓜爆料,网友投稿,吃瓜素材,吃瓜线索,吃瓜原帖,网曝吃瓜爆料",
    ogType: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "网曝吃瓜",
        alternateName: "网曝吃瓜 · 网友爆料投稿聚集地",
        url: "https://wangbaochigua.example/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://wangbaochigua.example/?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "网曝吃瓜",
        description: site.intro,
        email: site.email,
        foundingDate: site.since,
        knowsAbout: ["娱乐爆料", "网友投稿", "事件时间线整理", "内容核实"],
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "最新爆料投稿条目",
        itemListElement: posts.slice(0, 8).map((p, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: `https://wangbaochigua.example/post/${p.slug}`,
          name: p.title,
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroBand />
        <CategoryStrip posts={posts} />
        <LeadStories posts={posts} />
        <FeedWithSidebar posts={posts} />
        <TopicBanner posts={posts} />
        <StatsBand />
        <div className="bg-background-100/60">
          <FaqAccordion items={faqs} idPrefix="home-faq" />
        </div>
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}